<template>

    <div class="table-responsive">
        <table :class="`${isDark ? '' : 'bg-white'}`" class="table text-nowrap align-middle mb-0 ">
            <thead>
                <tr class="text-center">
                    <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                        赛事
                    </th>
                    <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                        开赛
                    </th>
                    <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 "
                        v-if="matchStatus != 'cp'">
                        当前时间
                    </th>
                    <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                        主队
                    </th>
                    <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 "
                        v-if="matchStatus != 'cp'">
                        当前比分
                    </th>
                    <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                        客队
                    </th>
                    <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 "
                        v-if="matchStatus === 'js'">
                        <span>
                            <feather-icon icon="TrendingUpIcon" size="15" />
                            指数
                        </span>
                        <span class="ms-5">|</span>
                        <span class="ms-5" id="popover-target-2" variant="outline-primary">
                            技术
                            <feather-icon icon="YoutubeIcon" size="15" />
                        </span>
                    </th>
                    <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                        提示时间
                    </th>
                    <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                        提示盘口
                    </th>
                    <th scope="col" v-if="matchStatus != 'cp'"
                        class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                        提示比分
                    </th>
                    <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                        提示类型
                    </th>

                    <th scope="col" v-if="matchStatus === 'ls'"
                        class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ">
                        结果
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in resultData" :key="item.matchId" class="text-center">
                    <td class="shadow-none lh-1">
                        <div class="d-flex align-items-center">

                            <img v-if="item.gameImg != null" :src="`http://lcsjfx.com/football/${item.gameImg}`"
                                class="rounded-circle " width="20" height="20" alt="user" />
                            <!-- <span class="d-block">{{ item.matchName }} </span> -->
                            <span class="text-primary font-weight-bolder">{{ item.matchName }}</span>
                            <span class="text-primary font-weight-bolder ms-5" v-if="item.keynote != 0">
                                <feather-icon icon="HeartIcon" class=" text-danger mb-1" />
                                <span class=" text-danger ms-1">{{item.keynoteStr}}</span>
                            </span>
                        </div>
                    </td>
                    <td>
                        {{ item.matchTime.substring(5) }}

                    </td>
                    <td v-if="matchStatus != 'cp'">
                        <span class="fs-lg-15"><feather-icon icon="WatchIcon" size="12" v-if="matchStatus === 'js'" />
                            {{ item.nowstatus }}
                            <span class="text-success blinking" v-if="matchStatus === 'js'">′</span></span>
                    </td>
                    <td class="shadow-none lh-1 ">
                        <div class="d-flex ">
                            <b-avatar :src="`http://lcsjfx.com/football/${item.homeImg}`" size="22" />
                            <!-- <span class="">{{ data.value }}</span>

                            <img v-if="item.homeImg != null" :src="`http://lcsjfx.com/football/${item.homeImg}`"
                                width="20" height="20" class="rounded-1 me-10" alt="project-image" /> -->

                            <span class="d-block ms-10">{{ item.teams1 }}</span>
                        </div>
                    </td>
                    <td class="shadow-none lh-1" v-if="matchStatus != 'cp'">
                        <div class="d-flex align-items-center">

                            <b-badge class="profile-badge" variant="light-success me-10">
                                <h6 class="fw-black mb-0">{{ item.nowscore.split('-')[0] }}</h6>
                            </b-badge>

                            ：

                            <b-badge class="profile-badge" variant="light-danger">
                                <h6 class="fw-black mb-0">{{ item.nowscore.split('-')[1] }}</h6>
                            </b-badge>
                            <!-- <span class="fw-bold text-danger text-badge d-inline-block me-10"
                                v-if="matchStatus === 'js'">
                                <h6 class="fw-black mb-0">{{ item.nowscore.split('-')[1] }}</h6>
                            </span> -->
                        </div>
                    </td>
                    <td class="shadow-none lh-1">
                        <div class="d-flex align-items-center">
                            <span class="d-block me-10">{{ item.teams2 }}</span>
                            <b-avatar :src="`http://lcsjfx.com/football/${item.guestImg}`" size="22" />
                        </div>
                    </td>
                    <td class="shadow-none lh-1 fw-bold text-body-tertiary " v-if="matchStatus === 'js'">
                        <div class="justify-content-between text-success" style="cursor:pointer;">
                            <span :id="'popover-target-zs_' + item.matchId" variant="outline-primary">
                                <feather-icon icon="TrendingUpIcon" size="15" />
                            </span>
                            <span class="ms-10">|</span>
                            <span class="ms-10" :id="'popover-target-js_' + item.matchId" variant="outline-primary">
                                <feather-icon icon="YoutubeIcon" size="15" />
                            </span>
                        </div>
                    </td>
                    <td class="shadow-none lh-1 fw-bold text-body-tertiary text-warning">
                        {{ item.status }} <span>′</span>
                    </td>
                    <td class="shadow-none lh-1 fw-bold text-body-tertiary ">
                        <span class="text-danger">{{ item.handicap }}</span>
                    </td>
                    <td class="shadow-none lh-1 fw-medium text-body-tertiary" v-if="matchStatus != 'cp'">
                        <span class="text-primary">{{ item.score }}</span>
                    </td>
                    <td class="shadow-none lh-1 fw-medium">
                        <span class="badge bg-primary fs-10"
                            v-if="item.betType.includes('大') || item.betType.includes('主') || item.betType == '胜'">{{
                                item.betType }}</span>
                        <span class="badge bg-info fs-10"
                            v-if="item.betType.includes('小') || item.betType.includes('客') || item.betType.includes('负')">{{
                                item.betType }}</span>
                        <span class="badge bg-dark fs-10" v-if="item.betType.includes('平')">{{ item.betType }}</span>
                    </td>

                    <td class="shadow-none lh-1 fw-medium text-body-tertiary" v-if="matchStatus === 'ls'">
                        <span class="text-danger fs-20 font-weight-bold"
                            v-if="item.result === '赢' || item.result === '赢半'">
                            <feather-icon icon="CheckIcon" size="20" /></span>
                        <span class="text-dark" v-else>{{ item.result }}</span>
                    </td>

                    <zs :id="item.matchId" :matchModel="item.matchModel" v-if="matchStatus === 'js'"></zs>
                    <Js :matchData="item" v-if="matchStatus === 'js'"></Js>
                </tr>
            </tbody>
        </table>

    </div>


</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'

import zs from './Zs.vue'
import Js from './Jstj.vue'



export default ({

    components: {
        zs,
        Js
    },

    props: {
        matchStatus: {
            type: String, // 指定props的类型为Array  
        },
        resultData: {
            type: Array, // 指定props的类型为Array  
            default: () => [] // 提供一个默认值，以防父组件没有传递该prop  
        }
    },

    data() {
        return {

        }
    },

    setup() {
        const { skin } = useAppConfig()

        const isDark = computed(() => skin.value === 'dark')

        return { skin, isDark }
    },

});
</script>

<style lang="css" scoped>
/* 定义一个闪烁动画 */
@keyframes blink {

    /* 从0%开始到100%，‌通过opacity属性在1（‌完全不透明）‌和0（‌完全透明）‌之间交替 */
    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }
}

/* 应用闪烁动画到一个类 */
.blinking {
    /* 使用无限次重复闪烁动画 */
    animation: blink 1s infinite;
}
</style>